<ng-template #mediaContent let-item="item" let-size="size">
  @if (item.video; as video) {
    <div [style.height.px]="size.dh" class="video-wrapper">
      <app-video
        [autoplay]="true"
        [cover]="true"
        [isLoop]="video.isLoop ?? true"
        [isMuted]="video.isMuted ?? true"
        [mp4Url]="video.mp4Url"
        [previewImage]="video.image" />
    </div>
  } @else if (item.image) {
    <app-image [image]="item.image" [size]="size" class="img" />
  }
  @if (item.legend; as legend) {
    <figcaption>
      <hr class="separator" />
      <p [innerHTML]="legend" class="legend"></p>
    </figcaption>
  }
</ng-template>

@if (data().items && data().items.length) {
  <section class="gallery-layout-7">
    @if (data().items; as items) {
      <div class="container">
        <div class="row">
          @if (items[0]; as item) {
            <figure class="figure col-lg-12 col-xs-12 item-0">
              <ng-container
                *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 1200, dh: 760, mh: 207 } }" />
            </figure>
          }
        </div>
        <div class="row">
          @if (items[1]; as item) {
            <figure class="figure col-lg-6 col-xs-6 item-1">
              <ng-container
                *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 588, dh: 760, mh: 203 } }" />
            </figure>
          }
          @if (items[2]; as item) {
            <figure class="figure col-lg-5 col-lg-offset-1 col-xs-6 item-2">
              <ng-container
                *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 486, dh: 625, mh: 203 } }" />
            </figure>
          }
        </div>
      </div>
    }
  </section>
}
